import { atom, selector } from "recoil";
import { storage } from "@/utils/storage";


export const resourceState = atom<any>({
    key: "resourceState",
    default: storage.get("resources") || [],
});

